import React, { useState, useEffect } from 'react';
import AdminUsers from './AdminUsers';
import AdminAccountants from './AdminAccountants';

function Admin({ state, setState }) {
    const [option, setOption] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='modal_body'>
            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='buttonscontainer'>
                        <button className='button' onClick={() => setOption(<AdminUsers state={state} setState={setState} />)}>Users</button>
                        <button className='button' onClick={() => setOption(<AdminAccountants state={state} setState={setState} />)}>Accountants</button>
                    </div>
                </div>
            </div>
            {option}
        </div>
    );
}

export default Admin;